import { styled } from '@material-ui/core';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { commonStyles, getDarkElevatedBarStyles } from 'UI/constants/styles';

const DEFAULT_PADDING = 3;

export const DrawerHeader = styled(CardHeader)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  boxShadow: '0px 3px 7px 0px #0000000f',
  padding: theme.spacing(DEFAULT_PADDING),
  ...getDarkElevatedBarStyles(theme, 'down')
}));

export const DrawerContentContainer = styled(Grid)({
  flexGrow: 1,
  overflowY: 'auto'
});

export const DrawerFooter = styled(CardActions)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  padding: theme.spacing(DEFAULT_PADDING),
  boxShadow: commonStyles.drawerFooter.boxShadow,
  ...getDarkElevatedBarStyles(theme, 'up')
}));

export const useStyles = makeStyles(theme => ({
  root: {
    padding: ({ hasPaddingContent }) => (hasPaddingContent ? theme.spacing(DEFAULT_PADDING) : 0)
  },
  contentWrapperStyles: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  }
}));
